import React from "react";
import { PlaydateInvite, SeenStatus, User } from "../../gql/types"; // Adjust import path if needed
import { TagVariant } from "./InfoTag";
import PlaydateInviteBaseUnit from "./PlaydateInviteBaseUnit";
import { inboundTagsResolver } from "./tags/inboundTagResolver";

interface PlaydateInviteInboundUnitProps {
    user?: User;
    invite: PlaydateInvite;
    onResponse: () => void;
}

const PlaydateInviteInboundUnit: React.FC<PlaydateInviteInboundUnitProps> = ({ user, invite, onResponse }) => {
    // 1) Check if this invite is "new" based on guestUpdate.seenState
    const isNew = invite.guestUpdate?.seenState === SeenStatus.New;
    const topLeftTags: Array<{ label: string; variant: TagVariant }> = inboundTagsResolver(invite);
    // One of the guests is the viewer, so we use the guest length - 1
    const otherGuestCount = invite.guests && invite.guests.length > 1
        ? invite.guests.length - 1
        : 0;

    return (
        <PlaydateInviteBaseUnit
            user={user}
            isNew={isNew}
            isInbound={true}
            infoTags={topLeftTags}
            otherGuestsCount={otherGuestCount}
            representedPerson={invite.organizer}
            invite={invite}
            onResponse={onResponse}
        />
    );
};

export default PlaydateInviteInboundUnit;
